import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';

import { RectangleLoader } from '../../../Components/Loader';
import {
  ids as reservationStyleIds,
  styles as reservationStyles,
} from '../../../Components/Reservation/styles';
import themeStyle from '../../../Theme/styles';
import breakpoints from '../../../Theme/styles/breakpoints';
import {
  ids as platformStyleIds,
  styles as platformStyles,
} from '../../../Theme/styles/platform';

import OverviewLoader from './OverviewLoader';

const OverviewAndPartySizeLoader = () => {
  return (
    <View
      dataSet={{ media: reservationStyleIds.boxContainer }}
      style={reservationStyles.boxContainer}
    >
      <View
        dataSet={{ media: platformStyleIds.webOnly }}
        style={platformStyles.webOnly}
      >
        <View
          dataSet={{ media: reservationStyleIds.box }}
          style={[reservationStyles.box, themeStyle.spacingBottomMedium]}
        >
          <OverviewLoader />
        </View>
      </View>
      <View
        dataSet={{ media: reservationStyleIds.box }}
        style={reservationStyles.box}
      >
        <View
          dataSet={{ media: ids.partySizeWrapper }}
          style={styles.partySizeWrapper}
        >
          <View
            dataSet={{ media: ids.partySizeContainer }}
            style={styles.partySizeContainer}
          >
            <RectangleLoader height={87} />
          </View>
          <View
            dataSet={{ media: ids.buttonContainer }}
            style={styles.buttonContainer}
          >
            <View style={{ borderRadius: 150, overflow: 'hidden' }}>
              <RectangleLoader height={49} />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  partySizeWrapper: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRow,
    ...themeStyle.alignItemsEnd,
    [`@media ${breakpoints.lg}`]: {
      ...themeStyle.flexDirectionCol,
      alignSelf: 'stretch',
    },
  },
  partySizeContainer: {
    ...themeStyle.flex1,
    ...themeStyle.spacingRightMedium,
    [`@media ${breakpoints.lg}`]: {
      ...themeStyle.spacingBottomMedium,
      marginRight: 0,
      alignSelf: 'stretch',
    },
  },
  buttonContainer: {
    ...themeStyle.flex1,
    ...themeStyle.spacingBottomMedium,
    [`@media ${breakpoints.lg}`]: {
      marginBottom: 0,
      alignSelf: 'stretch',
    },
  },
});

export default OverviewAndPartySizeLoader;
